import React, { FC, useCallback, memo, useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import { useLazyQuery } from '@apollo/client';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { SearchProjectSessionsDoc } from '@minecraft.graphql-operations';
import ErrorMessage from '@minecraft.error-message';
import { FilterData } from '../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../shared/utils';

type Props = {
  name: FilterData['name'];
  projectId: number;
  label: FilterData['label'];
};

const Sessions: FC<Props> = ({ name, projectId, label }) => {
  const [getSessions, { data, loading, error }] = useLazyQuery(SearchProjectSessionsDoc, {
    variables: {
      projectId,
      pageInput: {
        pageNumber: 1,
        pageSize: 200,
      },
    },
  });

  const handleSessionsFetch = useCallback((): void => {
    getSessions({});
  }, [getSessions]);

  const sessionsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(_sortBy(data?.auditionSessionsByProject?.objects, 'sortOrder'), 'name');
  }, [data?.auditionSessionsByProject?.objects]);

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withSelectAll
      isMultipleSelect
      isLoading={loading}
      name={name}
      toggleLabel={label}
      optionsTotalCount={data?.auditionSessionsByProject?.totalCount}
      options={sessionsOptions}
      onOptionsFetch={handleSessionsFetch}
    >
      {error && <ErrorMessage error={error} />}
    </DropdownWithChildren>
  );
};

export default memo(Sessions);
